import { useQuery } from '@tanstack/react-query';
import {
  getCategories,
  getModels,
  getBrandsFromDataService,
  searchVehicles,
  getVehicleByCode,
} from '@features/vehicles/services/vehicleDataService';

const BASE = 'vehicleData';

const vehicleDataQueryKeys = {
  categories: () => [BASE, 'categories'],
  models: (data) => [BASE, 'models', data],
  brands: (data) => [BASE, 'brands', data],
  search: (data) => [BASE, 'search', data],
  byCode: (code) => [BASE, 'byCode', code],
};

export const useGetCategories = ({ enabled = true } = {}) => {
  return useQuery({
    queryKey: vehicleDataQueryKeys.categories(),
    queryFn: getCategories,
    enabled,
    staleTime: 1000 * 60 * 60,
  });
};

export const useGetVehicleDataModels = ({ categoryId, stateId }, { enabled = true } = {}) => {
  return useQuery({
    queryKey: vehicleDataQueryKeys.models({ categoryId, stateId }),
    queryFn: () => getModels({ categoryId, stateId }),
    enabled: enabled && !!categoryId && stateId !== undefined,
    staleTime: 1000 * 60 * 60,
  });
};

export const useGetVehicleDataBrands = ({ categoryId, stateId, modelId }, { enabled = true } = {}) => {
  return useQuery({
    queryKey: vehicleDataQueryKeys.brands({ categoryId, stateId, modelId }),
    queryFn: () => getBrandsFromDataService({ categoryId, stateId, modelId }),
    enabled: enabled && !!modelId,
    staleTime: 1000 * 60 * 60,
  });
};

export const useSearchVehicles = ({ brandId, modelId, categoryId, stateId }, { enabled = true } = {}) => {
  return useQuery({
    queryKey: vehicleDataQueryKeys.search({ brandId, modelId, categoryId, stateId }),
    queryFn: () => searchVehicles({ brandId, modelId, categoryId, stateId }),
    enabled: enabled && !!brandId && !!modelId && !!categoryId,
    staleTime: 1000 * 60 * 60 * 24 * 7,
  });
};

export const useGetVehicleByCode = (code, { enabled = true } = {}) => {
  return useQuery({
    queryKey: vehicleDataQueryKeys.byCode(code),
    queryFn: () => getVehicleByCode(code),
    enabled: enabled && !!code,
    staleTime: 1000 * 60 * 60 * 24 * 7,
  });
};
